import { render, staticRenderFns } from "./PorletControlTrabajo.vue?vue&type=template&id=6626cab0"
import script from "./PorletControlTrabajo.vue?vue&type=script&lang=js"
export * from "./PorletControlTrabajo.vue?vue&type=script&lang=js"
import style0 from "./PorletControlTrabajo.vue?vue&type=style&index=0&id=6626cab0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports